function pad(n, width, z) {  z = z || '0';  n = n + '';  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;}

export class ImageSequence {
	constructor(container, width, height, prefix, firstFrame, lastFrame, imageExtension) {
		this.container = container;
		this.prefix = prefix;
		this.width = width;
		this.height = height;
		this.firstFrame = firstFrame;
		this.lastFrame = lastFrame;
		this.extn = imageExtension;
		this.currentIndex = 0;
		this.framesPerSecond = 30;
		this.updateTimer = null;
		this.startIndex = 0;
		this.startTime = null;
		this.callBackDidCompleteSequence = null;
		this.sequenceCompletedOnce = false;
		this.completionCallback = null;
		this.imagePreloader = null

		// $(this.container).css("overflow","hidden");
		this.container.style.overflow = 'hidden';
		this.container.innerHTML = "";

		this.canvas = document.createElement("canvas");
		this.canvas.style.position = "absolute";
		this.canvas.style.top = "0px";
		this.canvas.style.left = "0px";
		this.canvas.style.width = width + "px";
		this.canvas.style.height = height + "px";
		this.canvas.width = this.width;
		this.canvas.height = this.height;
		//$(this.container).prepend(this.canvas);
		this.container.insertBefore(this.canvas, this.container.childNodes[0]);

		this.imageNameArray = [];
		var padBy = 1;
		if (lastFrame > 9) {
			padBy = 2;
		}
		if (lastFrame > 99) {
			padBy = 3;
		}
		if (lastFrame > 999) {
			padBy = 4;
		}
		if (lastFrame > 9999) {
			padBy = 5;
		}

		var index = 0;
		for (var i = firstFrame; i <= lastFrame; i++) {
			// console.log(`image path = ${process.env.PUBLIC_URL}${prefix}${pad(i,padBy)}.${imageExtension}`)
			this.imageNameArray[index++] = process.env.PUBLIC_URL + prefix + pad(i, padBy) + "." + imageExtension;
		}
		this.targetIndex = index - 1;
		this.lastIndex = index - 1;
	}
	jumpToFrame(index) {
		if (isNaN(index)) {
			console.log('It is not a number')
			return;
		}
		if (!this.allowLooping && index > this.imageNameArray.length - 1) {
			index = this.imageNameArray.length - 1
		} 
		this.currentIndex = index % this.imageNameArray.length;
		if (this.currentIndex === (this.imageNameArray.length - 1) && !this.allowLooping) {
			this.sequenceCompletedOnce = true;
			this.mouseDown = false;
			if (this.callBackDidCompleteSequence) {
				this.callBackDidCompleteSequence();
			}
		}

		if (this.container.classList.contains('hidden')) {
			this.loadedIndex = this.loadingIndex + 1;
			return;
		}
		var self = this;
		if (this.imagePreloader != null && 
			this.imagePreloader.loadedImages[this.imageNameArray[this.currentIndex]] != null &&
			this.imagePreloader.loadedImages[this.imageNameArray[this.currentIndex]].isLoaded) {
			// console.log(`using preloaded image at index ${this.currentIndex}`)
			var ctx = self.canvas.getContext('2d');
			ctx.clearRect(0,0, parseInt(self.width), parseInt(self.height));
	        ctx.drawImage(this.imagePreloader.loadedImages[this.imageNameArray[this.currentIndex]], 0,0, parseInt(self.width), parseInt(self.height));
		} else {
			var img = new Image();
			img.loadingIndex = this.loadingIndex++;
			img.onload = function(){
				if ((img.loadingIndex < self.loadedIndex && self.targetIndex > self.currentIndex) ||
					(img.loadingIndex > self.loadedIndex && self.targetIndex < self.currentIndex)) {
					return;
				}
				self.loadedIndex = img.loadingIndex;
				var ctx = self.canvas.getContext('2d');
				ctx.clearRect(0,0, parseInt(self.width), parseInt(self.height));
				ctx.drawImage(img, 0,0, parseInt(self.width), parseInt(self.height));
			}
			img.src = this.imageNameArray[this.currentIndex];
		}
	}
	jumpToPercentage(percentage) {
		const index = Math.floor(percentage * this.imageNameArray.length);
		this.jumpToFrame(index);
	}
	animateToFrameWithCompletion(targetFrame, completion) {
		this.targetIndex = targetFrame % this.imageNameArray.length;
		if (this.targetIndex === this.currentIndex) {
			if (completion) {
				completion();
			}
			return;
		}
		this.completionCallback = completion;
		this.resume();
	}
	animateToStartWithCompletion(completion) {
		if (this.currentIndex === 0) {
			completion();
			return;
		}
		var targetFrame = 0;
		if (this.currentIndex > this.imageNameArray.length / 2) {
			targetFrame = this.lastFrame;
		}
		this.targetIndex = targetFrame % this.imageNameArray.length;
		if (this.targetIndex === this.currentIndex) {
			if (completion) {
				completion();
			}
			return;
		}
		this.completionCallback = completion;
		this.resume();
	}
	updateFrame() {
		var currentTime = new Date();
		var dif = currentTime.getTime() - this.startTime.getTime();
		var elapsedFrames = Math.floor(dif / 1000 * this.framesPerSecond);
		if (this.startIndex > this.targetIndex) {
			elapsedFrames *= -1;
		}
		var newFrame = this.startIndex + elapsedFrames;
		this.jumpToFrame(newFrame);
		if (newFrame === this.targetIndex ||
			(this.startIndex > this.targetIndex && newFrame < this.targetIndex) ||
			(this.startIndex < this.targetIndex && newFrame > this.targetIndex)) {
			this.jumpToFrame(this.targetIndex);
			this.pause();
			if (this.completionCallback != null) {
				this.completionCallback();
			}
			if (this.looping) {
				this.jumpToFrame(0);
				this.resume();
			}
		}
	}
	pause() {
		clearInterval(this.updateTimer);
	}
	play() {
		this.resume();
	}
	resume() {
		this.startIndex = this.currentIndex;
		this.startTime = new Date();
		clearInterval(this.updateTimer);
		var temp = this;
		this.updateTimer = setInterval(function () { temp.updateFrame(); }, 16);
	}
	imageLoaded() {
		this.loadedCount++;
		if (this.loadedCount === this.imageNameArray.length) {
			this.isSequencePreloaded = true;
		}
	}
	appendSequence(prefix, firstFrame, lastFrame, imageExtension) {
		var padBy = 1;
		if (lastFrame > 9) {
			padBy = 2;
		}
		if (lastFrame > 99) {
			padBy = 3;
		}
		if (lastFrame > 999) {
			padBy = 4;
		}
		if (lastFrame > 9999) {
			padBy = 5;
		}

		var index = this.imageNameArray.length;
		for (var i = firstFrame; i <= lastFrame; i++) {
			this.imageNameArray[index++] = process.env.PUBLIC_URL + prefix + pad(i, padBy) + "." + imageExtension;
		}
		this.targetIndex = index - 1;
	}
	set didCompleteSequence(cb) {
		this.callBackDidCompleteSequence = cb;
	}
	get sequencePrefix() {
		return this.prefix;
	}
}



export const DragDirection = Object.freeze({"RightToLeft":1, "LeftToRight":2, "TopToBottom":3, "BottomToTop":4})
export class DragableImageSequence extends ImageSequence {
	constructor(container, width, height, prefix, firstFrame, lastFrame, imageExtension, dragDirection, allowLooping) {
		super(container, width, height, prefix, firstFrame, lastFrame, imageExtension);

		this.imageSequence = this;
		this.isHorizontal = (dragDirection === DragDirection.RightToLeft || dragDirection === DragDirection.LeftToRight);
		this.mouseDown = false;
		this.startPosition = null;
		this.startFrame = 0;
		//this.mult = 1.0;
		switch (dragDirection) {
			case DragDirection.RightToLeft:
			case DragDirection.BottomToTop:
				this.mult = 2.5;
				break;
			case DragDirection.LeftToRight:
			case DragDirection.TopToBottom:
				this.mult = -2.5;
				break;
			default:
				this.mult = 2.5;
		}
		this.allowLooping = allowLooping;
		this.callbackDragStopped = null;
		this.callbackDragStarted = null;
		this.callbackDragMoved = null;

		this.touchArea = document.createElement("div");
		this.touchArea.style.position = "absolute";
		this.touchArea.style.width = this.width + "px";
		this.touchArea.style.height = this.height + "px";

		var self = this;
		this.touchArea.addEventListener('touchstart', function (event) { self.touchBegan(event); }, false);
		this.touchArea.addEventListener('touchmove', function (event) { self.touchMove(event); }, false);
		this.touchArea.addEventListener('touchend', function (event) { self.touchEnd(event); }, false);
		this.touchArea.addEventListener('mousedown', function (event) { self.touchBegan(event); }, false);
		this.touchArea.addEventListener('mousemove', function (event) { self.touchMove(event); }, false);
		this.touchArea.addEventListener('mouseup', function (event) { self.touchEnd(event); }, false);
		this.touchArea.addEventListener('onmousedown', function (event) { self.touchBegan(event); }, false);
		this.touchArea.addEventListener('onmousemove', function (event) { self.touchMove(event); }, false);
		this.touchArea.addEventListener('onmouseup', function (event) { self.touchEnd(event); }, false);

		// $(this.container).append(this.touchArea);
		this.container.appendChild(this.touchArea);

	}
	touchBegan(event) {
		if (!this.allowLooping && this.sequenceCompletedOnce) {
			event.stopPropagation();
			event.preventDefault();
			return
		}
		this.mouseDown = true;
		this.startPosition = this.getCursorPosition(event, false);
		this.startFrame = this.imageSequence.currentIndex;
		this.imageSequence.pause();
		if (this.callbackDragStarted) {
			this.callbackDragStarted(this.imageSequence.currentIndex);
		}
		event.stopPropagation();
		event.preventDefault();
	}
	touchMove(event) {
		if (this.mouseDown) {
			var currentPosition = this.getCursorPosition(event, true);
			var dx = currentPosition[0] - this.startPosition[0];
			var dy = currentPosition[1] - this.startPosition[1];
			var delta = -dx;
			var touchDist = parseInt(this.touchArea.style.width);
			if (!this.isHorizontal) {
				delta = -dy;
				touchDist = parseInt(this.touchArea.style.height);
			}
			var newIndex = Math.floor(this.startFrame + this.mult * delta * this.imageSequence.imageNameArray.length / touchDist);
			if (!this.allowLooping && newIndex < this.currentIndex) {
				event.stopPropagation();
				event.preventDefault();
				return
			}
			if (newIndex < 0) {
				newIndex = this.imageSequence.imageNameArray.length + newIndex;
			}
			this.imageSequence.jumpToFrame(newIndex);


			if (this.callbackDragMoved) {
				this.callbackDragMoved(this.imageSequence.currentIndex);
			}
			event.stopPropagation();
			event.preventDefault();
		}
	}
	touchEnd(event) {
		this.mouseDown = false;
		if (this.callbackDragStopped) {
			this.callbackDragStopped(this.imageSequence.currentIndex);
		}
		event.stopPropagation();
		event.preventDefault();
	}
	getCursorPosition(e) {
		var x = 0;
		var y = 0;
		var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
		var is_explorer = ((navigator.userAgent.indexOf('MSIE') > -1) || (navigator.userAgent.indexOf('Mozilla') > -1));
		var is_firefox = navigator.userAgent.indexOf('Firefox') > -1;
		var is_safari = navigator.userAgent.indexOf("Safari") > -1;
		if (e.touches != null && e.touches.length > 0) {
			return [e.touches[0].clientX, e.touches[0].clientY];
		}
		if ((is_safari || is_chrome || is_explorer) && !e.targetTouches && !is_firefox) {
			x = e.offsetX;
			y = e.offsetY;
			return [x, y];
		}
		else if (e.targetTouches) {
			x = e.layerX;
			y = e.layerY;
			return [x, y];
		}
		else if (e.layerX) {
			x = e.layerX;
			y = e.layerY;
		}
		else if (e.offsetX) {
			x = e.offsetX;
			y = e.offsetY;
		}
		return [x, y];
	}

	set dragStopped(cb) {
		this.callbackDragStopped = cb;
	}
	set dragStarted(cb) {
		this.callbackDragStarted = cb;
	}
	set dragMoved(cb) {
		this.callbackDragMoved = cb;
	}

}

export const PinchDirection = Object.freeze({"Closing":1, "Opening":2})
export class PinchableImageSequence extends ImageSequence {
	constructor(container, width, height, prefix, firstFrame, lastFrame, imageExtension, pinchDirection, allowsReverse) {
		super(container, width, height, prefix, firstFrame, lastFrame, imageExtension);

		this.imageSequence = this;
		this.isHorizontal = true;
		this.mouseDown = false;
		this.startPosition = null;
		this.startFrame = 0;
		this.currentScale = 1.0;
		this.currentPinchScale = 1.0;
		this.allowsReverse = allowsReverse;
		switch (pinchDirection) {
			case PinchDirection.Closing:
				this.mult = 2.0;
				break;
			case PinchDirection.Opening:
				this.mult = -2.0;
				break;
			default:
				this.mult = 2.0;
		}
		this.callbackPinchStopped = null;
		this.callbackPinchStarted = null;
		this.callbackPinchChanged = null;

		this.touchArea = document.createElement("div");
		this.touchArea.style.position = "absolute";
		this.touchArea.style.width = this.width + "px";
		this.touchArea.style.height = this.height + "px";

		var self = this;
		this.touchArea.addEventListener('gesturestart', function (event) { self.gestureStart(event); }, false);
		this.touchArea.addEventListener('gesturechange', function (event) { self.gestureChange(event); }, false);
		this.touchArea.addEventListener('gestureend', function (event) { self.gestureEnd(event); }, false);

		// $(this.container).append(this.touchArea);
		this.container.appendChild(this.touchArea);

	}
	gestureStart(event) {
		this.startingPinchScale = this.currentScale;
		this.currentPinchScale = event.scale;
		// console.log(`the starting event scale = ${event.scale}`)
		// console.log(`the starting pinch scale = ${this.startingPinchScale}`)
		if (this.callbackPinchStarted) {
			this.callbackPinchStarted(this.startingPinchScale)
		}
	};
	gestureChange(event) {
		const scaleDelta = this.currentPinchScale - event.scale;
		this.currentPinchScale = event.scale;
		this.currentScale = this.currentScale - (scaleDelta * this.mult);
		this.currentScale = this.currentScale < 0.0 ? 0.0 : this.currentScale > 1.0 ? 1.0 : this.currentScale;
		const percent = 1 - this.currentScale;
		if (!this.allowsReverse) {
			const index = Math.floor(percent * this.imageNameArray.length);
			if (index < this.currentIndex) {
				event.preventDefault();
				return
			}
		}
		// console.log(`The percent changed to = ${percent}`)
		this.jumpToPercentage(percent)
		if (this.callbackPinchChanged) {
			this.callbackPinchChanged(this.currentScale)
		}
		event.preventDefault();
	};
	gestureEnd(event) {
		// console.log(`the ending event scale = ${event.scale}`)
		if (this.callbackPinchStopped) {
			this.callbackPinchStopped(this.currentScale)
		}
		event.preventDefault();
	};

	set pinchStopped(cb) {
		this.callbackPinchStopped = cb;
	}
	set pinchStarted(cb) {
		this.callbackPinchStarted = cb;
	}
	set pinchChanged(cb) {
		this.callbackPinchChanged = cb;
	}
}

export class DraggablePinchZoomImageSequence extends DragableImageSequence {
	constructor(container, width, height, prefix, firstFrame, lastFrame, imageExtension) {
		super(container, width, height, prefix, firstFrame, lastFrame, imageExtension);

		this.draggableSequence = this;
		this.imageSequence = this;
		this.maxScale = 3.0;
		this.minScale = 1.0;
		this.currentScale = 1.0;
		this.translateX = 0.0;
		this.translateY = 0.0;
		this.touchLocation = [0, 0];
		this.startingPinchScale = 1.0;


		var ds = this.draggableSequence;
		var ta = ds.touchArea;

		ds.imageSequence.container.removeChild(ta);

		ds.touchArea = document.createElement("div");
		ds.touchArea.style.position = "absolute";
		ds.touchArea.style.width = this.width + "px";
		ds.touchArea.style.height = this.height + "px";
		ds.imageSequence.container.insertBefore(ds.touchArea, ds.imageSequence.innerDiv.nextSibling);

		ta = ds.touchArea;

		var self = this;

		ta.addEventListener('touchstart', function (event) { self.touchBegan(event); }, false);
		ta.addEventListener('touchmove', function (event) { self.touchMove(event); }, false);
		ta.addEventListener('touchend', function (event) { self.touchEnd(event); }, false);
		ta.addEventListener('mousedown', function (event) { self.touchBegan(event); }, false);
		ta.addEventListener('mousemove', function (event) { self.touchMove(event); }, false);
		ta.addEventListener('mouseup', function (event) { self.touchEnd(event); }, false);
		ta.addEventListener('onmousedown', function (event) { self.touchBegan(event); }, false);
		ta.addEventListener('onmousemove', function (event) { self.touchMove(event); }, false);
		ta.addEventListener('onmouseup', function (event) { self.touchEnd(event); }, false);

		ta.addEventListener('mousewheel', function (event) { self.scroll(event); }, false);


		ta.addEventListener('gesturestart', function (event) { self.gestureStart(event); }, false);
		ta.addEventListener('gesturechange', function (event) { self.gestureChange(event); }, false);
		ta.addEventListener('gestureend', function (event) { self.gestureEnd(event); }, false);



		DraggablePinchZoomImageSequence.prototype.touchBegan = function (event) {
			this.touchLocation = this.draggableSequence.getCursorPosition(event);
			this.draggableSequence.touchBegan(event);
		};
		DraggablePinchZoomImageSequence.prototype.touchMove = function (event) {
			var lastLocation = this.touchLocation;
			this.touchLocation = this.draggableSequence.getCursorPosition(event);
			if (this.draggableSequence.mouseDown) {
				if (this.currentScale === 1) {
					this.draggableSequence.touchMove(event);
				}
				else {
					this.translate(this.touchLocation[0] - lastLocation[0], this.touchLocation[1] - lastLocation[1]);
				}
				event.preventDefault();
			}
		};
		DraggablePinchZoomImageSequence.prototype.touchEnd = function (event) {
			this.draggableSequence.touchEnd(event);

		};
		DraggablePinchZoomImageSequence.prototype.scroll = function (event) {

			this.zoomAtRateWithCenter(event.deltaY / 100, this.draggableSequence.getCursorPosition(event));
			event.preventDefault();
		};
		DraggablePinchZoomImageSequence.prototype.gestureStart = function (event) {
			this.startingPinchScale = this.currentScale;
		};
		DraggablePinchZoomImageSequence.prototype.gestureChange = function (event) {
			this.currentScale = event.scale * this.startingPinchScale;
			this.zoomAtRateWithCenter(0, this.touchLocation);
			event.preventDefault();
		};
		DraggablePinchZoomImageSequence.prototype.gestureEnd = function (event) {
		};
		DraggablePinchZoomImageSequence.prototype.zoomAtRateWithCenter = function (rate, center) {
			this.currentScale -= rate;
			this.currentScale = Math.min(this.maxScale, Math.max(this.minScale, this.currentScale));

			var ds = this.draggableSequence;
			var rd = ds.imageSequence.relativeDiv;
			var width = this.width;
			var height = this.height;

			this.translateX = -(this.currentScale * (center[0] - width / 2) - (center[0] - width / 2));
			this.translateY = -(this.currentScale * (center[1] - height / 2) - (center[1] - height / 2));


			var transform = " scale(" + this.currentScale + "," + this.currentScale + ")";
			var translate = " translate(" + this.translateX + "px, " + this.translateY + "px)";

			rd.style["transform"] = translate + transform;
			rd.style["-ms-transform"] = translate + transform;
			rd.style["-webkit-transform"] = translate + transform;

		};
		DraggablePinchZoomImageSequence.prototype.translate = function (deltaX, deltaY) {
			var ds = this.draggableSequence;
			var rd = ds.imageSequence.container;
			
			this.translateX += (deltaX);
			this.translateY += (deltaY);

			var transform = " scale(" + this.currentScale + "," + this.currentScale + ")";
			var translate = " translate(" + this.translateX + "px, " + this.translateY + "px)";

			rd.style["transform"] = translate + transform;
			rd.style["-ms-transform"] = translate + transform;
			rd.style["-webkit-transform"] = translate + transform;
		};

	}
}
